export default __webpack_public_path__ + "static/media/TableSelect.b6d23c52.png";